import AccountScreenRedesignDescriptor from './account-redesign';
import AccountScreenRefiveDescriptor from './account-refive';
import AccountScreenCanteenDescriptor from './account-canteen';
import AccountScreenAramarkDescriptor from './account-aramark';
import AccountScreenCompanyKitchenDescriptor from './account-companykitchen';
import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';

const typeDescriber = {
  [BuildTypes.aramark]: AccountScreenAramarkDescriptor,
  [BuildTypes.canteen]: AccountScreenCanteenDescriptor,
  [BuildTypes.default]: AccountScreenRedesignDescriptor,
  [BuildTypes.companykitchen]: AccountScreenCompanyKitchenDescriptor,
  [BuildTypes.refive]: AccountScreenRefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
